import { taskStatusesSlice } from "./taskStatusesSlice";
import * as defaultActions from "../../../../../redux/_common";

export const QPARAMS_CHANGED = "taskStatuses/QParamsChanged";
const { actions } = taskStatusesSlice;
const moduleUrl = '/api/activity/taskstatuses'

export const setValidationErrors = actions.setValidationErrors;

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);